import { render, staticRenderFns } from "./TrafficChart.vue?vue&type=template&id=4f21bce5&scoped=true&"
import script from "./TrafficChart.vue?vue&type=script&lang=js&"
export * from "./TrafficChart.vue?vue&type=script&lang=js&"
import style0 from "./TrafficChart.vue?vue&type=style&index=0&id=4f21bce5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f21bce5",
  null
  
)

export default component.exports